import React from 'react'
import imgixLoader from 'lib/imgixLoader'
import Image, { ImageProps } from 'next/image'

const ImgixImage: React.FC<ImageProps> = (props) => {
  return <Image {...props} loader={imgixLoader} />
}

export default ImgixImage
